module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-lps_btn-132f238546105c4c135025487b3e6699.png";